<template>
  <div style="height:100vh; background:#fff;overflow:scroll;overflow-x:hidden">

  



  
 
 
<div class="header py-md-5 pt-md-0 pt-3 ">
 <div class="container py-1 "  >
      <div  style="padding:0px;margin:0px">





  <header id="header" class="header d-flex align-items-center justify-content-center" role="banner" style="padding:0px">
    
    <a href='https://websitelearners.com/'  style="text-decoration:none!important;width:300px">
                    <img src="https://websitelearners.com/content/uploads/2016/09/logo.svg" alt="Website Learners"  style="width:100%" />
                  </a>
  </header>
</div>
</div>
</div>








 
  <div class="header d-none py-5  " style=" ">
    <div class="container py-1 "  >
      <div class="row" style="padding:0px;margin:0px">
        <div class="col-12" style="padding:0px;margin:0px">
          <div class=" d-flex align-items-center justify-content-between">
            <router-link to='/'>
              <img src="https://websitelearners.com/app/uploads/2016/09/logo.svg" style="" class="headlogo" >
            </router-link>
              <img src="https://firebasestorage.googleapis.com/v0/b/wl-shopping.appspot.com/o/images%2FMenu%20Icon.svg?alt=media&token=31566e5e-fb81-41b1-9032-e97da43a1254" class="d-md-none d-block" v-on:click='drawer=true' style="width:30px">
              <div class="d-md-flex  d-none align-items-center">
                
               
                 
                   <div class="nabelm ml-4 mr-2">
                     <router-link to='/contact'>
                  <p style="margin-bottom: 0px">Contact</p>
                </router-link>
                </div>
                 
                

               

              </div>
          </div>
        </div>
      </div>
    </div>
  </div>

 
<div  v-if='mobilebox' style="position:fixed;top:0;left:0;right:0;bottom:0;z-index:1000000000000" class="d-flex align-items-center justify-content-center">
  <div style="position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.3)"></div>



  <div    style="width:400px;background:#fff;border-radius:5px;position:relative;z-index:1000;margin-bottom:100px" class="p-4 d-none">
    <h3 style="text-align:center">Add Info</h3>
    <div style="text-align:center"  >
      <img src="https://websitelearners.com/app/uploads/2016/09/logo.svg" style="height:30px">
    </div>
  


    <form v-on:submit.prevent='addmobilenumber' >
      
 
       
    <div class="mt-2">
      
      <div class="mt-4">
      <input  v-model='mobile' style="border:1px solid #C5C6C9;height:50px" type="text" class="form-control" name="" placeholder="Mobile">
    </div>
      
     <button   style="width:100%;outline:none;border:none;box-shadow:none;background:#53BA90;color:#fff;border-radius:4px;padding:10px;text-align:center;cursor:pointer" class="mt-4">
                   {{addmobtxt}}
                  </button>


 
   
 



    </div>
  </form>
</div>



  
  <div    style="width:600px;background:#fff;border-radius:5px;position:relative;z-index:1000;padding-bottom:90px!important" class="p-4  ">
    <h3 style=" font-size:22px">More Details</h3>
    <div class="d-flex mt-4  align-items-center" style="border:1px solid #F8E9CD;background:#FFF8EB;padding:15px;border-radius:4px">
      <svg width="25" height="25" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.2181 2.78219C12.5081 -0.927353 6.49282 -0.927766 2.78237 2.78219C-0.927664 6.49214 -0.927251 12.5073 2.78237 16.2177C6.49241 19.9268 12.5077 19.9272 16.2181 16.2177C19.9278 12.5073 19.9273 6.49256 16.2181 2.78219ZM10.739 13.6304C10.739 14.3148 10.1843 14.8695 9.49984 14.8695C8.81541 14.8695 8.26068 14.3148 8.26068 13.6304V8.67384C8.26068 7.98943 8.81541 7.43471 9.49984 7.43471C10.1843 7.43471 10.739 7.98943 10.739 8.67384V13.6304ZM9.47795 6.55575C8.7642 6.55575 8.28836 6.05019 8.30323 5.42608C8.28836 4.77182 8.7642 4.28154 9.49241 4.28154C10.221 4.28154 10.682 4.77223 10.6973 5.42608C10.6969 6.05019 10.2214 6.55575 9.47795 6.55575Z" fill="#F1BB51"/>
</svg>
<p style="margin-bottom:0px;color:#D09E3B;font-size:15px;font-weight:300;margin-left:16px" >  
Please add your mobile number to continue with the purchase.</p>

    </div>
   


    <form v-on:submit.prevent='addmobilenumber' >
      
 <div class="d-flex  " style="margin-top:30px">

  <div style="flex:1 "  class="pr-2">
    <p style="color:#8392A6;font-size:16px;font-weight:300">First Name</p>
    <div class="mt-3">
       <input  v-model='fname' style="border:1px solid #EAEFF5;height:50px;background:#F8FBFF;border-radius:4px" type="text" class="form-control" name="" placeholder="First Name">
    </div>
  </div>

  <div style="flex:1" class="pl-2">
    <p style="color:#8392A6;font-size:16px;font-weight:300">Last Name</p>
    <div class="mt-3">
       <input  v-model='lname' style="border:1px solid #EAEFF5;height:50px;background:#F8FBFF;border-radius:4px" type="text" class="form-control" name="" placeholder="Last Name">
    </div>
  </div>
   
 </div>
       
    <div class="mt-5">
          <p style="color:#8392A6;font-size:16px;font-weight:300">Phone No</p>

   <div class="d-flex">
    <div  class="mr-3">
       <select v-model='codenum' class="form-control" style="border:1px solid #EAEFF5;height:50px;background:#F8FBFF; ">
         <option value="+91">+91</option>
         <option value="+11">+11</option>
       </select>
    </div>
        <div class="" style="width:200px">
      <input required=""  v-model='mobile' style="border:1px solid #EAEFF5;height:50px;background:#F8FBFF" type="text" class="form-control" name="" placeholder="Mobile">
    </div>

   </div>
                <p style="color:red;font-size:16px;font-weight:300" v-if='!valid' >Enter a valid mobile number</p>

     <button   style="width:100%;outline:none;border:none;box-shadow:none;background:#53BA90;color:#fff; padding:15px;text-align:center;cursor:pointer;position:absolute;bottom:0;left:0;right:0" class="mt-4">
                   {{addmobtxt}}
                  </button>


 
   
 



    </div>
  </form>
</div>




  </div>








 

<div  style="min-height: 90vh;"    >
   <div v-if="signbox=='signin'" style="width:400px;background:#fff;border-radius:5px;position:relative;z-index:1000;box-shadow:0 0 10px rgba(0,0,0,0.1);margin:0px auto;margin-top:100px;" class="p-4">
    <h3 style="text-align:center;font-size: 18px;font-weight: 500;">Welcome
 </h3>
 <p style="font-size:16px;color:#999;text-align: center;">Enter your email to get started.
</p>
     
    <form v-on:submit.prevent='signin' style="">
      

    <div class="mt-4">
      <div class="mt-4">
      <input required=""  v-model='email' style="border:1px solid #C5C6C9;height:50px" type="email" class="form-control" name="" placeholder="Email">
    </div>
     <div class="mt-4">


      <input  required="" v-model='password' style="border:1px solid #C5C6C9;height:50px" type="password" class="form-control" name="" placeholder="Password">

        

    </div>


    <p style="color:red;font-size:16px" class="mt-2">{{errorMessage}}</p>
     <button   style="width:100%;outline:none;border:none;box-shadow:none;background:#53BA90;color:#fff;border-radius:4px;padding:10px;text-align:center;cursor:pointer" class="mt-4">
                    {{signintxt}}
                  </button>

                  <p style="margin-top: 20px;text-align:center;color: #333;font-size: 16px;font-weight: 500;">Not regestered yet? <span v-on:click="signbox='signup'"  style="cursor: pointer;text-align:center;color: #53BA90;font-size: 16px;font-weight: 500;">Create now</span></p>

                 
 
                 

 



    </div>
  </form>
  </div>



  <div v-if="signbox=='signup'" style="width:400px;background:#fff;border-radius:5px;position:relative;z-index:1000;box-shadow:0 0 10px rgba(0,0,0,0.1);margin:0px auto;margin-top: 100px;" class="p-4">
  <h3 style="text-align:center;font-size: 18px;font-weight: 500;">Welcome
 </h3>
 <p style="font-size:16px;color:#999;text-align: center;">Create new account now.
</p>    
    <form v-on:submit.prevent='signup'>
      
    <div class="mt-2">
       <div class="mt-4">
      <input v-model='username' style="border:1px solid #C5C6C9;height:50px" type="text" class="form-control" name="" placeholder="Username">
                           <div class="error errtxt" style="" v-if="!$v.username.minLength">Username Must be more than 4 digits</div>

    </div>
     <div class="mt-4">
      <input v-model='mobile' style="border:1px solid #C5C6C9;height:50px" type="number" class="form-control" name="" placeholder="Mobile">
               <div class="error errtxt" style="" v-if="!$v.mobile.minLength">Mobile Must be 10 Digits</div>

    </div>
       <div class="mt-4 d-none">
      <input v-model='business' style="border:1px solid #C5C6C9;height:50px" type="text" class="form-control" name="" placeholder="Business">
    </div>
      <div class="mt-4">
      <input v-model='emails' style="border:1px solid #C5C6C9;height:50px" type="email" class="form-control" name="" placeholder="Email">

    </div>
     <div class="mt-4">
      <input v-model='passwords' style="border:1px solid #C5C6C9;height:50px" type="password" class="form-control" name="" placeholder="Password">

                     <div class="error errtxt" style="" v-if="!$v.passwords.minLength">Password Must be 8 Digits</div>

    </div>

    <p style="color:red;font-size:16px" class="mt-2">{{errorMessagereg}}</p>
     <button   style="width:100%;outline:none;border:none;box-shadow:none;background:#53BA90;color:#fff;border-radius:4px;padding:10px;text-align:center;cursor:pointer" class="mt-4">
          

                    {{signuptxt}}
                  </button>
                                      <p class="typo__p errtxt" v-if="submitStatus === 'ERROR'">Please fill the form correctly.</p>



                  <div style="border-top:1px solid #DADBDD" class="pt-3 mt-4">
                    <p style="color:#62646A;text-align:center">Already a member? <span style="display:inline;color:#53BA90;cursor:pointer" v-on:click="signbox='signin'">Sign In</span></p>
                  </div>


    </div>
        </form>

  </div>


</div>

  
 
 
 
<div class="" style="background:#F9FBFE;padding:10px 0">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="d-flex align-items-center justify-content-between">
          <div>
            <router-link to='/'>
            <img src="https://websitelearners.com/app/uploads/2016/09/logo.svg" style="width:200px" class="img-fluid">
          </router-link>
          </div>
          <p style="color:#98A5B6;font-size:18px;font-weight:400;margin:35px 0"    >2021 © All rights reserved.</p>
          
        </div>
      </div>
      
    
    </div>
  </div>
</div>


   </div>


</template>

<script>
  const fb = require('../firebase/firebaseconfig.js')
import firebase from 'firebase'
import { required, minLength, between,maxLength } from 'vuelidate/lib/validators'
 import axios from 'axios'

export default {
 
     
      props:['products','loaded','signedin','tokens'],
  data () {

        return{
    
          
          packagebox:'basic',
          submitStatus:'',
          loginbox:false,
          errorMessagereg:'',
               addmobtxt:'Add Mobile Number',
               errorMessage:'',
     
     emails:'',
          signbox:'signup',
          email:'',
          token:null,
          password:'',
          packagename:'',
          business:'',
     signuptxt:'Sign Up',
     mobilebox:false,
     signintxt:'Sign In',
          username:'',
          mobile:'',
          mobiles:'',

          quantity:1,
          valid:true,
          stripebox:false,
          loading:false,
          codenum:'+91',
          amount:100,
          pulishableKey:'pk_test_51IWEQsK1HkaHJgqqMXIJ2BSupMr8My1pPnDFcY5oCyAYAap6TkQeKBSOeq9C06pgHBzub8RQO2HpWejsic8PFGv200TLXY93Cx',
 
          charge:null,
          packagebox:'basic',
          fname:'',
          lname:'',

          name:'',
          razmob:'',
          profileimg:'',
          email:'',
             signedinby:'google',
   profiletext:'',
   name:'',
   drawer:false,
 
       
          loginbox:false,
     
          signbox:'signup',
          testdatas:['vjyf','fghngfhfg'],
          email:'',
          passwords:'',
          mobilebox:false,
          addmobtxt:'Add Mobile Number',
          packagename:'',
          business:'',
     signuptxt:'Sign Up',
     signintxt:'Sign In',
          username:'',
          name:'',
          mobile:'',
          profileimg:'',
             signedinby:'google',
   profiletext:''
 
        }
     
    
  },
   validations: {

   
        emails: {
      required,

       
    },
   
      passwords: {
    required,

      minLength: minLength(8)
    },

    mobile: {
    required,

      minLength: minLength(10),
      maxLength:maxLength(10)
    },
    
     username: {
    required,

      minLength: minLength(4),
   
    }
  },
  created(){


 

 


 

 if(fb.auth.currentUser!=null){
  console.log(fb.auth.currentUser)
 this.name=fb.auth.currentUser.displayName


 this.fname=fb.auth.currentUser.displayName.split(' ')[0]
 this.lname=fb.auth.currentUser.displayName.split(' ')[1]
if( fb.auth.currentUser.providerData[0].providerId=='google.com'){


  var x=fb.auth.currentUser.photoURL.split('wlshops').length-1
 

  this.profileimg=fb.auth.currentUser.photoURL.split('wlshops')[x]
    this.signedinby='google'



}else{

  this.signedinby='email'
  this.profiletext=fb.auth.currentUser.displayName[0].toUpperCase()



}









 var des=false

var vm=this

 fb.db.collection("wlshopusers").where("email", "==", fb.auth.currentUser.email)
    .get()
    .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
            console.log(doc.id, " => ", doc.data());


des=true




        });





        if(des){

 
if(vm.tokens!=null){




 fb.db.collection('wlshopusers').doc(fb.auth.currentUser.uid).update({

     
      token:vm.tokens
       
    
      }).then(()=>{
        vm.$router.push({ path:'/'})
      })

}

vm.$router.push({ path:'/'})



}else{
  

vm.mobilebox=true
vm.loginbox=false



}


    })
    .catch((error) => {
        console.log("Error getting documents: ", error);
    });




 }
 





 
 
  
 
  },
   mounted(){
   (function(w, d, $) {




$('li.menu-item-has-children > a').on("click touch", function(e) {
 

        e.preventDefault();
        if($(w).width() <= 768) {


          $('.sub-menu').css('min-width', $(w).width());
          $('.sub-menu-column .sub-menu').css('min-width', '0px');
          $('.products-sub-menu .sub-menu').css('min-width', $(w).width()-50);
          if( $(this).hasClass('on') ) {
            if($(this).parent().hasClass('sub-menu-columns')){
              $(this).next('.sub-menu').slideUp(350);
              $(this).removeClass('on');
            } else if($(this).parent().hasClass('sub-menu-column')){
              $(this).next('.sub-menu').slideUp(350).delay(150).queue(function (next) {
                $(this).parent('.sub-menu-column').css('height', 'auto');
                next();
              });
              $(this).removeClass("on");
            } else if($(this).parent('li.menu-item-has-children').hasClass('login-menu')) {
              $(this).next('.sub-menu').slideUp(350);
              $(this).removeClass('on');
              $(this).parents('.nav-right').css('background-color', '#FFF');
            } else {
              $(this).next('.sub-menu').slideUp(350);
              $(this).removeClass('on');
            }
          }
          else {
            if($(this).parent().hasClass('sub-menu-columns')){
              $("li.menu-item-has-children > a").not($(this)).next('.sub-menu').slideUp(350).delay(350).queue(function (next) {
                $('.sub-menu-column').css('height', 'auto');
                next();
              });
              $("li.menu-item-has-children > a").not($(this)).removeClass("on");
              $(this).next('.sub-menu').slideDown(350);
              $(this).addClass('on');
            } else if($(this).parent().hasClass('sub-menu-column')){
              let submenuHeight1 = $(this).next('.sub-menu').height();
              $(this).parent('.sub-menu-column').css('height', 63+submenuHeight1);
              $(this).next('.sub-menu').slideDown(350);
              $(this).addClass('on');
            } else if($(this).parent('li.menu-item-has-children').hasClass('login-menu')) {
              $(this).parents('.nav-right').css('background-color', '#F9FCFC');
              $("li.menu-item-has-children > a").not($(this)).next('.sub-menu').slideUp(350).delay(350).queue(function (next) {
                $('.sub-menu-column').css('height', 'auto');
                next();
              });
              $("li.menu-item-has-children > a").not($(this)).removeClass("on");
              $(this).next('.sub-menu').slideDown(350);
              $(this).addClass('on');
            } else {
              $("li.menu-item-has-children > a").not($(this)).next('.sub-menu').slideUp(350).delay(350).queue(function (next) {
                $('.sub-menu-column').css('height', 'auto');
                next();
              });
              $("li.menu-item-has-children > a").not($(this)).removeClass("on");
              $(this).next('.sub-menu').slideDown(350);
              $(this).addClass('on');
            }
          }
        }
      });



var toggleClose = $('.close'),
menuWrapper = $('.main-nav'),
          bodyControl     = $('body'),
          mouse_is_inside = false;


      $('.navigate').click( function() {

   
        bodyControl.removeClass("active");
        menuWrapper.addClass("active");
        bodyControl.addClass("active");
        return false;
      });


      toggleClose.click( function() {
        bodyControl.removeClass("active");
        menuWrapper.removeClass("active");
        return false;
      });

      })(window, document, jQuery);

} 
    
   ,
  computed:
  { 

  },

   
  methods:{ 
 
    async addmobilenumber(){



var vm=this
if(this.mobile.length!=10){
 


this.valid=false

setTimeout(()=>{

vm.valid=true
},3000)


}else{

this.valid=true



 await fb.db.collection('wlshopusers').doc(fb.auth.currentUser.uid).set({

     
        email:fb.auth.currentUser.email,
        name:this.fname+''+this.lname,
        mobile:this.mobile,
        business:'',
               signintype:'google'
       
    
      })


var user = fb.auth.currentUser;

if(vm.lname!=undefined){
  var name=vm.lname
}else{
  var name=vm.fname
}
 

 
user.updateProfile({

  displayName: vm.fname+''+name,
  phoneNumber:vm.codenum+vm.mobile,
  photoURL:vm.codenum+vm.mobile+'wlshops'+fb.auth.currentUser.photoURL

 }).then(function() {
   
 
    axios.post('https://us-central1-wl-shopping.cloudfunctions.net/sendWelcomeemail?&name='+ vm.fname+''+name)
       


}).catch(function(error) {
  // An error happened.
});


vm.$emit('setsignedin',true)
vm.mobilebox=false


if(vm.tokens!=null){


 
 await fb.db.collection('wlshopusers').doc(fb.auth.currentUser.uid).update({

     
      token:vm.tokens
       
    
      }) 
}


 

 this.$router.push({ path:'/'})



vm.signuptxt='Account Created'

 
setTimeout(()=>{

vm.signuptxt='Sign Up'
vm.signbox='signin'
vm.loginbox=false

},3000)


}
},



   async signwithgoogle(){
 


var provider = new firebase.auth.GoogleAuthProvider();

 fb.auth.signInWithPopup(provider).then(async(res)=>{
 




 }).catch(e=>{

  console.log(e)
 })
    },
    signout(){
 
      fb.auth.signOut()
     this.$emit('setsignedin',false)
    },
   async signin(){

var vm=this
 


// do your submit logic here
        vm.submitStatus = 'PENDING'
      

 



 
this.signintxt='Signing In...'
var vm=this
var vm=this
fb.auth.signInWithEmailAndPassword(this.email, this.password)
  .then(async(user) => {



 var docRef = fb.db.collection("wlframeusers").doc(fb.auth.currentUser.uid);

docRef.get().then((doc) => {
    if (doc.exists) {
      
        console.log("Document data:", doc.data());

vm.signintxt='Signed In Successfully'

vm.$emit('setsignedin',[true,doc.data()])
 

 if(this.$route.query.invite!=undefined){ 
  this.$router.push({ path:'/frameio?invite='+this.$route.query.invite})
 }else{
   this.$router.push({ path:'/frameio'})
 }

setTimeout(()=>{

vm.signintxt='Sign In'
vm.signbox='signin'
vm.loginbox=false

},3000)



    } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
    }
}).catch((error) => {
    console.log("Error getting document:", error);
});

 





  })
  .catch((error) => {

    vm.signintxt='Sign In'

    var errorCode = error.code;
    var errorMessage = error.message;
  vm.errorMessage=errorMessage
   setTimeout(()=>{
 
 vm.errorMessage=''
},3000)

 

  });

 



    },
   async signup(){




var vm=this

 this.$v.$touch()
      if (this.$v.$invalid) {
        this.submitStatus = 'ERROR'

   setTimeout(() => {
          vm.submitStatus = 'OK'
        }, 1000)

 

      } else {



this.signuptxt='Signing up...'

  fb.auth.createUserWithEmailAndPassword(this.emails,this.passwords).then(async() => {





 var color = '#';
    for (var i = 0; i < 6; i++) {
        color += Math.floor(Math.random() * 10);
    }
 

 fb.db.collection('wlframeusers').doc(fb.auth.currentUser.uid).set({

     
        email:this.emails,
        name:this.username,
        mobile:this.mobile,
        business:this.business,
          signintype:'email',
          color:color,
        password:this.passwords
    
      })





/*
var user = fb.auth.currentUser;

user.updateProfile({
  displayName:this.username,
  phoneNumber:this.mobile,
  photoURL:this.mobile+'wlshops'+fb.auth.currentUser.photoURL
 }).then(function() {
    axios.post('https://us-central1-wl-shopping.cloudfunctions.net/sendWelcomeemail?to='+fb.auth.currentUser.email+'&name='+fb.auth.currentUser.displayName)
  // Update successful.
}).catch(function(error) {
  // An error happened.
});

*/



 this.$emit('setsignedin',[true,{
  email:this.emails,
        name:this.username,
        mobile:this.mobile,
        business:this.business,
          signintype:'email',
        password:this.passwords,
          color:color,
 }])

 


 if(this.$route.query.invite!=undefined){ 
  this.$router.push({ path:'/frameio?invite='+this.$route.query.invite})
 }else{
   this.$router.push({ path:'/frameio'})
 }





this.signuptxt='Account Created'

var vm=this
setTimeout(()=>{

vm.signuptxt='Sign Up'
vm.signbox='signin'
vm.loginbox=false

},3000)


  })
.catch((error) => {
   

vm.signuptxt='Sign Up'
    var errorCode = error.code;
    var errorMessage = error.message;
   vm.errorMessagereg=errorMessage
   setTimeout(()=>{
 
 vm.errorMessagereg=''
},3000)



  });
     

 
 




}
    },
   
    
  }
 

   
   
    
 
  
}
</script>
<style scoped >
 

</style>
 



// WEBPACK FOOTER //
// src/components/login.vue